import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//Routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";
import { useDispatch } from "react-redux";
import { getLanguage } from "../slices/auth/menu/thunk";

/**
 * Index component representing the main entry point for rendering routes.
 *
 * This component uses the React Router's `Routes` and `Route` components to
 * define and render the application routes. It includes both public routes
 * (accessible without authentication) and authenticated routes (protected).
 *
 * @component
 */
const Index = () => {
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(getLanguage());
	})

	const renderNestedRoutes = (nestedRoutes) => {
		return nestedRoutes.map((nestedRoute, idx) => (
			<Route key={idx} path={nestedRoute.path} element={nestedRoute.component}>
				{nestedRoute.children && renderNestedRoutes(nestedRoute.children)}
			</Route>
		));
	};

	return (
		<React.Fragment>
			<Routes>
				<Route>
					{publicRoutes.map((route, idx) => (
						<Route
							path={route.path}
							element={
								<NonAuthLayout>
									{route.component}
								</NonAuthLayout>
							}
							key={idx}
							exact={true}
						/>
					))}
				</Route>
				<Route>
					{authProtectedRoutes.map((route, idx) => (
						<Route key={idx} path={route.path} element={
							<AuthProtected>
								<VerticalLayout>{route.component}</VerticalLayout>
							</AuthProtected>
						}>
							{route.children && renderNestedRoutes(route.children)}
						</Route>
					))}
				</Route>
			</Routes>
		</React.Fragment>
	);
};

export default Index;